import { useState, useEffect } from "react";
import "./user-preferences.css";
import PageHeading from "../common/page_heading/PageHeading";
import Loader from "../common/loader/Loader";
import Button from "../common/button/Button";
import UserService from "../../services/UserService";
import UtilityService from "../../services/UtilityService";

const PREFERENCE_DEFS = [
	{
		name: "DEFAULT_VIEW",
		label: "Default View",
		options: [
			{ key: "kanban", label: "Kanban" },
			{ key: "list", label: "List" },
		],
	},
	// ← add more defs here, e.g.
	// {
	//   name: "FONT_SIZE",
	//   label: "Font Size",
	//   options: [ { key: "sm", label: "Small" }, { key: "md", label: "Medium" }, { key: "lg", label: "Large" } ]
	// }
];

const { alert } = UtilityService;

export default function UserPreferences() {
	const [prefs, setPrefs] = useState({});
	const [loading, setLoading] = useState(true);
	const [saving, setSaving] = useState(false);

	useEffect(() => {
		setLoading(true);
		UserService.getPreferences()
			.then((list) => {
				const loaded = list.reduce((acc, { name, value }) => {
					acc[name] = value;
					return acc;
				}, {});
				const initial = {};
				for (let def of PREFERENCE_DEFS) {
					initial[def.name] = loaded[def.name] ?? def.options[0].key;
				}
				setPrefs(initial);
			})
			.catch((err) => console.error("Failed loading prefs:", err))
			.finally(() => setLoading(false));
	}, []);

	const handleChange = (prefName, key) => {
		setPrefs((prev) => ({ ...prev, [prefName]: key }));
	};

	const handleSave = () => {
		setSaving(true);
		UserService.updatePreferences(prefs)
			.then(() => {
				alert({ type: "success", text: "Saved User Preferences!" });
			})
			.catch(() => {
				alert({ type: "error", text: "Error Occured!" });
			})
			.finally(() => setSaving(false));
	};

	{
		loading && (
			<div className="container-loader">
				<Loader />
			</div>
		);
	}

	return (
		<>
			<div className="user-preferences">
				<PageHeading section="Settings" title={"User Preferences"} />
				<div className="userpreferences__body">
					{PREFERENCE_DEFS.map((def) => (
						<div key={def.name} className="userpreferences__section userpreferences__form__title">
							<div className="user-preferences__label">{def.label}</div>
							<div className="pill-container">
								{def.options.map((opt) => (
									<div key={opt.key} className={"pill" + (prefs[def.name] === opt.key ? " pill--active" : "")} onClick={() => handleChange(def.name, opt.key)}>
										{opt.label}
									</div>
								))}
							</div>
						</div>
					))}

					<div class="userpreferences__form__footer">
						<Button text={saving ? "Saving…" : "Save Preferences"} onClick={handleSave} disabled={saving} />
					</div>
				</div>
			</div>
		</>
	);
}
